import gettext from '@eb/gettext';
import { ANCHOR_LINK } from '@eb/eds-nav-list-item';
import { getAnalyticsClickHandler } from '@eb/site-analytics';
import {
    SIGN_IN_HEADER_CLICKED,
    OVERVIEW_HEADER_CLICKED,
    PRICING_HEADER_CLICKED,
    CONTACT_HEADER_CLICKED,
    BLOG_HEADER_CLICKED,
    SUCCESS_STORIES_HEADER_CLICKED,
    PRODUCT_DEMO_HEADER_CLICKED,
    EVENT_GUIDES_HEADER_CLICKED,
    GA_ACTION_PRICING,
    GA_ACTION_CONTACT_SALES,
    GA_ACTION_RESOURCES_BLOG,
    GA_ACTION_RESOURCES_SUCCESS_STORIES,
    GA_ACTION_RESOURCES_PRODUCT_DEMO,
    GA_ACTION_RESOURCES_EVENT_GUIDE,
    GA_ACTION_SIGNIN,
    CATEGORY_ORGANIZER_MARKETING_HEADER,
    LABEL_HELP_CENTER,
    LOCALE_SPECIFIC_URLS,
} from './constants';

const withJanusCheckpoint = (checkpointName, domain) => ({
    pageWillChange: true,
    domain,
    checkpointName,
});

export const getMarketingSignInLink = (
    requestPath,
    isAuthenticated,
    url,
    ebDomain,
) => {
    if (isAuthenticated) {
        return null;
    }

    return [
        {
            url,
            content: gettext('Sign In'),

            onClick: getAnalyticsClickHandler(
                {
                    requestPath,
                    action: GA_ACTION_SIGNIN,
                    category: CATEGORY_ORGANIZER_MARKETING_HEADER,
                },
                withJanusCheckpoint(SIGN_IN_HEADER_CLICKED, ebDomain),
            ),
        },
    ];
};

export const getMarketingLinks = ({ requestPath, serverUrl, ebDomain }) => [
    {
        url: `${serverUrl}/organizer/overview/`,
        content: gettext('Overview'),
        onClick: getAnalyticsClickHandler(
            {
                requestPath,
                action: GA_ACTION_RESOURCES_BLOG,
                category: CATEGORY_ORGANIZER_MARKETING_HEADER,
            },
            withJanusCheckpoint(OVERVIEW_HEADER_CLICKED, ebDomain),
        ),
    },
    {
        url: `${serverUrl}/organizer/pricing/`,
        content: gettext('Pricing'),
        onClick: getAnalyticsClickHandler(
            {
                requestPath,
                action: GA_ACTION_PRICING,
                category: CATEGORY_ORGANIZER_MARKETING_HEADER,
            },
            withJanusCheckpoint(PRICING_HEADER_CLICKED, ebDomain),
        ),
    },
];

export const getSalesLinks = ({ serverUrl, requestPath, ebDomain }) => [
    {
        url: `${serverUrl}/contact-sales/`,
        content: gettext('Contact Us'),
        onClick: getAnalyticsClickHandler(
            {
                requestPath,
                action: GA_ACTION_CONTACT_SALES,
                category: CATEGORY_ORGANIZER_MARKETING_HEADER,
            },
            withJanusCheckpoint(CONTACT_HEADER_CLICKED, ebDomain),
        ),
    },
];

export const getResourcesMenu = ({
    fallbackUrl = '/blog',
    requestPath,
    env,
}) => {
    const locale = env.localeInfo.locale;
    const localizedLinks = LOCALE_SPECIFIC_URLS[locale];
    let resourcesMenu = [];
    const { ebDomain } = env;

    if (localizedLinks) {
        const {
            blogLink,
            successStoriesLink,
            productDemoLink,
            eventGuidesLink,
        } = localizedLinks;

        resourcesMenu = [
            {
                label: gettext('Resources'),
                fallbackUrl,
                navItems: [
                    {
                        type: ANCHOR_LINK,
                        path: blogLink,
                        content: gettext('Blog'),
                        rel: 'noopener noreferrer',

                        onClick: getAnalyticsClickHandler(
                            {
                                requestPath,
                                action: GA_ACTION_RESOURCES_BLOG,
                                category: CATEGORY_ORGANIZER_MARKETING_HEADER,
                                label: LABEL_HELP_CENTER,
                            },
                            withJanusCheckpoint(BLOG_HEADER_CLICKED, ebDomain),
                        ),
                    },
                    {
                        type: ANCHOR_LINK,
                        path: successStoriesLink,
                        content: gettext('Success Stories'),
                        rel: 'noopener noreferrer',

                        onClick: getAnalyticsClickHandler(
                            {
                                requestPath,
                                action: GA_ACTION_RESOURCES_SUCCESS_STORIES,
                                category: CATEGORY_ORGANIZER_MARKETING_HEADER,
                                label: LABEL_HELP_CENTER,
                            },
                            withJanusCheckpoint(
                                SUCCESS_STORIES_HEADER_CLICKED,
                                ebDomain,
                            ),
                        ),
                    },
                    {
                        type: ANCHOR_LINK,
                        path: productDemoLink,
                        content: gettext('Product Demo'),
                        rel: 'noopener noreferrer',

                        onClick: getAnalyticsClickHandler(
                            {
                                requestPath,
                                action: GA_ACTION_RESOURCES_PRODUCT_DEMO,
                                category: CATEGORY_ORGANIZER_MARKETING_HEADER,
                                label: LABEL_HELP_CENTER,
                            },
                            withJanusCheckpoint(
                                PRODUCT_DEMO_HEADER_CLICKED,
                                ebDomain,
                            ),
                        ),
                    },
                    {
                        type: ANCHOR_LINK,
                        path: eventGuidesLink,
                        content: gettext('Event Guides'),
                        rel: 'noopener noreferrer',

                        onClick: getAnalyticsClickHandler(
                            {
                                requestPath,
                                action: GA_ACTION_RESOURCES_EVENT_GUIDE,
                                category: CATEGORY_ORGANIZER_MARKETING_HEADER,
                                label: LABEL_HELP_CENTER,
                            },
                            withJanusCheckpoint(
                                EVENT_GUIDES_HEADER_CLICKED,
                                ebDomain,
                            ),
                        ),
                    },
                ].filter(({ path }) => !!path),
            },
        ];
    }

    return resourcesMenu;
};
